// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from './state';

const SHOW_GLOBAL_OVERLAY = 'SHOW_GLOBAL_OVERLAY';
export const showGlobalOverlay = (name: ?string) => ({
  type: SHOW_GLOBAL_OVERLAY,
  name,
});

const HIDE_GLOBAL_OVERLAY = 'HIDE_GLOBAL_OVERLAY';
export const hideGlobalOverlay = (name: ?string) => ({
  type: HIDE_GLOBAL_OVERLAY,
  name,
});

const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
export const showTooltip = (name: ?string) => ({
  type: SHOW_TOOLTIP,
  name,
});

const SHOW_FAB = 'SHOW_FAB';
export const showFab = (name: ?string) => ({
  type: SHOW_FAB,
  name,
});

const SHOW_LOCAL_OVERLAY = 'SHOW_LOCAL_OVERLAY';
export const showLocalOverlay = (name: string) => ({
  type: SHOW_LOCAL_OVERLAY,
  name,
});

const HIDE_LOCAL_OVERLAY = 'HIDE_LOCAL_OVERLAY';
export const hideLocalOverlay = (name: string) => ({
  type: HIDE_LOCAL_OVERLAY,
  name,
});

const HIDE_ALL_OVERLAYS = 'HIDE_ALL_OVERLAYS';
export const hideAllOverlays = () => ({
  type: HIDE_ALL_OVERLAYS,
});

/** Add new toast to the list of open ones */
const LAUNCH_TOAST = 'LAUNCH_TOAST';
export const launchToast = (toast: string) => ({
  type: LAUNCH_TOAST,
  toast,
});

/** Close currently open toasts and just show the new one */
const LAUNCH_EXCLUSIVE_TOAST = 'LAUNCH_EXCLUSIVE_TOAST';
export const launchExclusiveToast = (toast: string) => ({
  type: LAUNCH_EXCLUSIVE_TOAST,
  toast,
});

/** Remove the toast from the list of open ones */
const REMOVE_TOAST = 'REMOVE_TOAST';
export const removeToast = (toast: string) => ({
  type: REMOVE_TOAST,
  toast,
});

export type Action =
  | ExtractReturn<typeof showGlobalOverlay>
  | ExtractReturn<typeof showFab>
  | ExtractReturn<typeof showLocalOverlay>
  | ExtractReturn<typeof hideLocalOverlay>
  | ExtractReturn<typeof launchToast>
  | ExtractReturn<typeof launchExclusiveToast>
  | ExtractReturn<typeof removeToast>;

const emptyState = () => ({
  global: null,
  tooltip: null,
  fab: null,
  locals: {},
  toasts: [],
});

export type State = {|
  global: ?string,
  tooltip: ?string,
  fab: ?string,
  locals: { [string]: boolean },
  toasts: string[],
|};

export default (state: State = emptyState(), action: AllActions): State => {
  switch (action.type) {
    case SHOW_GLOBAL_OVERLAY:
      return { ...state, global: action.name, locals: {}, tooltip: null };
    case HIDE_GLOBAL_OVERLAY:
      return !action.name || state.global === action.name ? { ...state, global: null } : state;
    case SHOW_FAB:
      return { ...state, fab: action.name };
    case SHOW_TOOLTIP:
      return { ...state, tooltip: action.name };
    case SHOW_LOCAL_OVERLAY:
      return { ...state, locals: { ...state.locals, [action.name]: true }, tooltip: null };
    case HIDE_LOCAL_OVERLAY:
      return { ...state, locals: { ...state.locals, [action.name]: false } };
    case HIDE_ALL_OVERLAYS:
      return { ...state, locals: {}, global: null };
    case LAUNCH_TOAST:
      return { ...state, toasts: [...state.toasts, action.toast] };
    case LAUNCH_EXCLUSIVE_TOAST:
      return { ...state, toasts: [action.toast] };
    case REMOVE_TOAST:
      // $FlowFixMe - according to flow there is no toast property in action
      return { ...state, toasts: state.toasts.filter(t => t !== action.toast) };
    default:
      return state;
  }
};
